<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        {{ title }}
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'review-index' }">
            Explore Review
          </router-link>
        </li>
        <li class="active">
          <span>Detail</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-md-6">
          <div class="box box-info">
            <div class="box-header with-border">
              <!-- <h3 class="box-title">Add Review</h3> -->
            </div>
            <table id="table" class="table table-bordered table-striped">
              <tr>
                <th><strong> Submitted Date </strong></th>
                <td>: {{ parseTime(detailReview.reviewed_at) }}</td>
              </tr>
              <tr>
                <th><strong> Type </strong></th>
                <td>: {{ detailReview.type }}</td>
              </tr>
              <tr>
                <th><strong> Account Name </strong></th>
                <td>: {{ detailReview.name }}</td>
              </tr>
              <tr>
                <th><strong> Email </strong></th>
                <td>: {{ detailReview.email }}</td>
              </tr>
              <tr>
                <th><strong> Status </strong></th>
                <td v-if="detailReview.approval_status === 0">
                  <div class="status-field">
                    :
                    <span class="status waiting-status">
                      Waiting for Approval
                    </span>
                  </div>
                </td>
                <td v-if="detailReview.approval_status === 1">
                  <div class="status-field">
                    :
                    <span class="status approved-status"> Approved </span>
                  </div>
                </td>
                <td v-if="detailReview.approval_status === 2">
                  <div class="status-field">
                    :
                    <span class="status rejected-status"> Rejected </span>
                  </div>
                </td>
              </tr>
              <tr>
                <th><strong> Reviewed Date </strong></th>
                <td>: {{ parseTime(detailReview.approval_date) || "-" }}</td>
              </tr>
              <tr>
                <th><strong> Review Description </strong></th>
              </tr>
              <tr>
                <td class="description-detail" colspan="2">
                  {{ detailReview.detail.description }}
                </td>
              </tr>
              <tr>
                <th><strong> Photo </strong></th>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="image-gallery">
                    <template v-if="detailReview.detail && checkImage">
                      <div
                        class="image-item img-thumbnail img-responsive"
                        v-for="(image, index) in detailReview.detail.photos"
                        :style="{ backgroundImage: `url('${getSize(image)}')` }"
                        :key="index"
                        @click="openModal"
                      ></div>
                    </template>
                    <template v-else>
                      <div>
                        <img class="no-video" src="/static/img/no-image.png" />
                      </div>
                    </template>
                  </div>
                </td>
              </tr>
              <tr>
                <th><strong> Video </strong></th>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="image-gallery">
                    <template v-if="(detailReview.detail && checkVideo)">
                      <video width="320" height="240" controls>
                        <source
                          :src="detailReview.detail.videos[0]"
                          type="video/mp4"
                        />
                      </video>
                    </template>
                    <template v-else>
                      <img class="no-video" src="/static/img/no-video.png" />
                    </template>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="col-md-6" v-if="detailReview.detail">
          <label for="name" class="col-sm-12 mt-5">Detail Product </label>
          <div>
            <img
              class="image-review"
              :src="detailReview.detail.product_image"
              alt="image-product"
            />
          </div>
          <div class="review-list row">
            <span class="review-detail-product col-md-3"> Product Name </span>
            <span class="col-md-7">
              : {{ detailReview.detail.product_name }}
            </span>
          </div>
          <div class="review-list row">
            <span class="review-detail-product col-md-3"> Merchant </span>
            <span class="col-md-7">
              : {{ detailReview.detail.merchant || "-" }}
            </span>
          </div>
          <div class="review-list row" v-if="destinationDetail.length">
            <span class="review-detail-product col-md-3"> Destination </span>
            <span class="col-md-7">
              : {{ destinationDetail[0] + ", " }}
              {{ destinationDetail[1] || "-" }}
            </span>
          </div>
          <div class="review-list row">
            <span class="review-detail-product col-md-3"> Booking Id </span>
            <span class="col-md-7">
              : {{ detailReview.booking_id || "-" }}
            </span>
          </div>
          <div class="review-list row">
            <span class="review-detail-product col-md-3"> Booking Date </span>
            <span class="col-md-7">
              : {{ parseTime(detailReview.detail.booking_at) || "-" }}
            </span>
          </div>
          <div class="review-list row">
            <span class="review-detail-product col-md-3"> Activity Date </span>
            <span v-if="detailReview.detail.travel_date.from === detailReview.detail.travel_date.to" class="col-md-7">
              : {{ parseTime(detailReview.detail.travel_date.from, 'YYYY-MM-DD') || "-"
              }}
            </span>
            <span v-else class="col-md-7">
              : {{ parseTime(detailReview.detail.travel_date.from, 'YYYY-MM-DD') || "-"
              }}{{
                parseTime(detailReview.detail.travel_date.to, 'YYYY-MM-DD')
                  ? " s.d. " + parseTime(detailReview.detail.travel_date.to, 'YYYY-MM-DD')
                  : ""
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          @click="approve"
          type="submit"
          class="btn btn-info pull-right approve-button"
          v-if="detailReview.approval_status === 0"
        >
          Approve
        </button>
        <button
          @click="reject"
          type="submit"
          class="btn btn-danger pull-right"
          v-if="detailReview.approval_status === 0"
        >
          Reject
        </button>
        <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
      </div>
    </section>
    <transition name="slideDown">
      <modal :title="detailReview.detail.product_name" class="modal-review"
      v-if="show.images">
        <div class="carousel-popup" v-if="detailReview.detail && checkImage">
          <VueSlickCarousel
            ref="c1"
            v-bind="settings"
            :asNavFor="c2"
            class="main-image"
            >
              <div
                v-for="(image, index) in detailReview.detail.photos"
                :key="index"
              >
              <img :src="image" class="image-carousel" />
            </div>
          </VueSlickCarousel>
    
          <VueSlickCarousel
            ref="c2"
            :asNavFor="c1"
            v-bind="settings2"
            class="thumb-carousel"
            >
            <div
                v-if="detailReview.detail && checkImage"
                v-for="(image, index) in detailReview.detail.photos"
                :key="index"
                class="image-carousel-thumb"
              >
              <img :src="image" class="image-carousel-bottom" />
            </div>
          </VueSlickCarousel>
        </div>
      </modal>
    </transition>
  </div>
</template>
<script>
import Common from '@/mixins/Common';
import bus from '@/utils/bus';
import Modal from '@/components/modules/common/Modal';
import Box from '@/components/modules/common/Box';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'ReviewForm',

  mixins: [Common],

  data() {
    return {
      title: 'Review Detail',
      detailReview: null,
      destinationDetail: [],
      c1: undefined,
      c2: undefined,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        dots: true,
        focusOnSelect: true,
      },
      settings2: {
        infinite: true,
        slidesToShow: 5,
        speed: 500,
        focusOnSelect: true,
      },
      show: {
        images: false,
      },
    };
  },
  components: {
    Box,
    Modal,
    VueSlickCarousel,
  },

  methods: {
    openModal() {
      this.c1 = this.$refs.c1;
      this.c2 = this.$refs.c2;
      this.$store.commit('SET_MODAL', 'image-modal');
      this.show.images = true;
      document.body.classList.add('locked');
    },
    getDetail() {
      this.axios
        .get(`/review/backoffice/${this.$route.params.id}`)
        .then((response) => {
          const data = response.data.data;

          this.detailReview = data;
          this.destinationDetail = data.detail.destination.split(',');
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }
        });
    },
    approve() {
      this.$swal({
        title: 'Confirmation',
        text: 'Are you sure want to APPROVE this review?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#666',
        confirmButtonText: 'Yes, Approve',
      }).then((result) => {
        if (result.value) {
          this.axios
            .patch(`review/backoffice/approve/${this.$route.params.id}`)
            .then(() => {
              bus.$emit('destroy-editor');
              this.$swal({
                title: 'Approve Succeed',
                text: 'The review will be appear in Customer Site.\nKlik OK to redirect to review list',
                type: 'success',
                timer: 5000,
              }).then((results) => {
                if (results) {
                  this.$router.go(-1);
                }
              });
            });
        }
      });
    },
    reject() {
      this.$swal({
        title: 'Confirmation',
        text: 'Are you sure want to REJECT this review?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#666',
        confirmButtonText: 'Yes, Reject',
      }).then((result) => {
        if (result.value) {
          this.axios
            .patch(`review/backoffice/reject/${this.$route.params.id}`)
            .then(() => {
              bus.$emit('destroy-editor');
              this.$swal({
                title: 'Reject Succeed',
                text: 'The review will not be appear in Customer Site.\nKlik OK to redirect to review list',
                type: 'success',
                timer: 5000,
              }).then((results) => {
                if (results) {
                  this.$router.go(-1);
                }
              });
            });
        }
      });
    },
    cancel() {
      bus.$emit('destroy-editor');
      this.$router.go(-1);
    },
  },

  computed: {
    checkVideo() {
      const dataVideo = this.detailReview.detail.videos;
      if (dataVideo === null) {
        return false;
      } else if (dataVideo.length < 1) {
        return false;
      } 
      return true;
    },
    checkImage() {
      const dataImages = this.detailReview.detail.photos;
      if (dataImages === null) {
        return false;
      } else if (dataImages.length < 1) {
        return false;
      } 
      return true;
    },
  },
  created() {
    this.getDetail();
  },
  mounted() {
    bus.$on('close-modal', () => {
      this.closeModals();
    });
  },

  destroyed() {
    bus.$off('close-modal');
  },
};
</script>

<style lang="scss" scoped>
.image-gallery {
  display: flex;
  flex-wrap: wrap;

  .image-item {
    position: relative;
    display: inline-block;
    width: calc(100% / 5 - 1.5rem);
    margin: 0.75rem;
    background: transparent center no-repeat;
    background-size: cover;

    &::after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
  }
}
.image-review {
  width: 350px;
  display: flex;
  margin: 30px 0 20px 20px;
}
.review-list {
  margin: 15px 0 15px 10px;
  .review-detail-product {
    font-weight: 700;
  }
}
.description-detail {
  max-width: 500px;
  word-wrap: break-word;
}
th,
td {
  padding: 5px 15px;
}
.status-field {
  margin: 5px 0;
  .status {
    border: 1px solid gray;
    border-radius: 16px;
    padding: 8px 16px;
    color: white;
    font-size: 16px;
    width: fit-content;
    font-weight: 600;
    &.approved-status {
      background-color: rgb(93, 201, 59);
    }
    &.waiting-status {
      background-color: rgb(85, 160, 255);
    }
    &.rejected-status {
      background-color: rgb(252, 23, 39);
    }
  }
}
.approve-button {
  margin-left: 10px;
  background-color: rgb(12, 101, 255);
}
.no-video {
  width: 220px;
  height: 140px;
  margin-bottom: 30px;
}
</style>
<style lang="scss">
.modal-review {
  .modal-dialog {
    width: 1100px !important;
  }
}
.carousel-popup {
  width: 100%;
  text-align: -webkit-center;
  .thumb-carousel {
    margin-top: 30px;
    width: 50%;
    .slick-current {
      .image-carousel-bottom {
        width: 100px;
        height: 100px;
        background-size: cover;
        border: 2px solid grey;
      }
    }
    .image-carousel-thumb {
      margin: 5px;
    }
    .image-carousel-bottom {
      width: 100px;
      height: 100px;
      padding: 5px;
      background-size: cover;
    }
  }
  .main-image {
    margin: 0 25px;
    .slick-prev:before, .slick-next:before {
      color: gray !important;
    }
    .image-carousel {
      width: auto;
      height: 450px;
      background-size: cover;
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/modules/review/Approval.vue